import { render, staticRenderFns } from "./PlatformInfoTable.vue?vue&type=template&id=d1e7d7e2&scoped=true"
import script from "./PlatformInfoTable.vue?vue&type=script&lang=js"
export * from "./PlatformInfoTable.vue?vue&type=script&lang=js"
import style0 from "./PlatformInfoTable.vue?vue&type=style&index=0&id=d1e7d7e2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1e7d7e2",
  null
  
)

export default component.exports